import React, { useMemo } from 'react';
import { WithClassname } from '../../../types';
import { Steps } from 'antd';
import {
  CheckCircleOutlined,
  EnvironmentOutlined,
  ShoppingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import classnames from 'classnames';
import { Routes } from '../../../routing/Router';
import collect from 'collect.js';
import { useNavigate } from 'react-router';

export default function OrderFlowStepper({ className }: WithClassname) {
  const navigate = useNavigate();

  const currentStepIndex = useMemo(() => {
    const activeRoute = collect(window.location.pathname.slice(1).split('/')).last();

    return (
      {
        [Routes.NewOrder.Root]: 0,
        [Routes.NewOrder.OrderItems]: 1,
        [Routes.NewOrder.OrderInfo]: 2,
        [Routes.NewOrder.OrderConfirmation]: 3,
      }[activeRoute] ?? null
    );
  }, [window.location.pathname]);

  const onClick = (index: number) => {
    const path = {
      0: `/${Routes.NewOrder.Root}`,
      1: `/${Routes.NewOrder.Root}/${Routes.NewOrder.OrderItems}`,
      2: `/${Routes.NewOrder.Root}/${Routes.NewOrder.OrderInfo}`,
      3: `/${Routes.NewOrder.Root}/${Routes.NewOrder.OrderConfirmation}`,
    }[index];

    navigate(path);
  };

  return (
    <Steps
      current={currentStepIndex}
      onChange={onClick}
      items={[
        {
          title: 'Customer details',
          icon: <UserOutlined />,
        },
        {
          title: 'Order items',
          icon: <ShoppingOutlined />,
        },
        {
          title: 'Order details',
          icon: <EnvironmentOutlined />,
        },
        {
          title: 'Order confirmation',
          icon: <CheckCircleOutlined />,
        },
      ]}
      className={classnames('my-md', className)}
    />
  );
}
